module.exports = __webpack_public_path__ + "img/oobit.08f87bc1.png";